export default "__VITE_ASSET__BYUlmVMA__"